import { Pipe, PipeTransform } from '@angular/core';
import { AppUrls } from "../app-urls";

@Pipe({
  name: 'formatDownloadUrl'
})
export class FormatDownloadUrlPipe implements PipeTransform {

  transform(fileGuid: string): string {
    return AppUrls.fileUrls.downloadFileUrl.replace('{0}', fileGuid);
  }

}
